import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'audit',
  entityPlural: 'audits',
  dataObject: 'dync-appshop-web',
  state: {
    publishable: false
  }
});
